
import React from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";

import LogoImg from "../../../assets/images/LOGO KIPIT.png";

import {
  FacebookOutlined,
  TwitterOutlined,
  YoutubeOutlined,
} from "@ant-design/icons"; // Importa los iconos de Ant Design
import {
  FACEBOOK_LINK,
  YOUTUBE_LINK,
  TWITTER_LINK,
} from "../../../services/Url.service";

const Footer = () => {
  return (
    <>
      <div className={styles.Footer}>
        <div className={styles.ContainerData}>
          <div className={styles.Logo}>
            <img src={LogoImg} alt="Logo" />
          </div>

          <div className={styles.Info}>
            <div className={styles.ColInfo}>
              <div className={styles.Title}>SOBRE PUNTOS</div>

              <div className={styles.Links}>
                <div className={styles.Link}>
                  <Link to={{ pathname: "/quienes-somos" }}>Quiénes somos</Link>
                </div>
                <div className={styles.Link}>
                  <Link to={{ pathname: "/quienes-somos" }}>
                    Misión y Visión
                  </Link>
                </div>
                <div className={styles.Link}>
                  <a href="#">Mi cuenta</a>
                </div>
              </div>
            </div>

            <div className={styles.ColInfo}>
              <div className={styles.Title}>POLÍTICAS</div>

              <div className={styles.Links}>
                <div className={styles.Link}>
                  <a href="#">Política de privacidad</a>
                </div>
                <div className={styles.Link}>
                  <a href="#">Términos y condiciones</a>
                </div>
              </div>
            </div>

            <div className={styles.ColInfo}>
              <div className={styles.Title}>CONTÁCTO</div>

              <div className={styles.Links}>
                <div className={styles.Link}>
                  <a href="#">servicioalcliente@puntos.com</a>
                </div>
                <div className={styles.Link}>
                  <a href="#">9999999999</a>
                </div>
              </div>
            </div>

            <div className={styles.ColInfo}>
              <div className={styles.Title}>SÍGUENOS</div>

              <div className={styles.Icons}>
                {/* Icono de Facebook */}
                {FACEBOOK_LINK && FACEBOOK_LINK !== "" && (
                  <div className={styles.Icon}>
                    <a href={FACEBOOK_LINK} target="_blank">
                      <FacebookOutlined />
                    </a>
                  </div>
                )}
                {TWITTER_LINK && TWITTER_LINK !== "" && (
                  <div className={styles.Icon}>
                    <a href={TWITTER_LINK} target="_blank">
                      <TwitterOutlined />
                    </a>
                  </div>
                )}

                {/* Icono de YouTube */}
                {YOUTUBE_LINK && YOUTUBE_LINK !== "" && (
                  <div className={styles.Icon}>
                    <a href={YOUTUBE_LINK} target="_blank">
                      <YoutubeOutlined />
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className={styles.AllRights}>
        © 2024 {process.env.REACT_APP_NAME} | Todos los derechos reservados
      </div>
    </>
    // <footer className="fullWidth" style={{ backgroundColor: '#000', color: '#fff', textAlign: 'center' }}>
    //   <div style={{ fontSize: '24px', marginBottom: '10px' }}>
    //     <a href={FACEBOOK_LINK} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', marginRight: '10px' }}>
    //       <FacebookOutlined />
    //     </a>
    //     <a href={TWITTER_LINK} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', marginRight: '10px' }}>
    //       <TwitterOutlined />
    //     </a>
    //     <a href={YOUTUBE_LINK} target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>
    //       <YoutubeOutlined />
    //     </a>
    //   </div>
    //   <p style={{ fontSize: '14px', marginTop: '0' }}>Copyright © 2024, {process.env.REACT_APP_NAME}</p>
    // </footer>
  );
};

export default Footer;
